import { FC } from 'react'
import { CheckIcon, PlayIcon } from 'lucide-react'
import { CourseType } from '../../../types'
import {
  formatMultipleString,
  formatVideoLength,
  getCourseCompletedStatus,
  getCourseLessonCount,
  getCourseVideoLength,
  getOptimizedImage
} from '../../../utils'
import { useGetCourseUrl } from '../../../utils/scripts/useGetCourseUrl'
import { StyledCourseListItem } from '.'

type Props = {
  course: CourseType
}

const CourseListItem: FC<Props> = ({ course }) => {
  const status = getCourseCompletedStatus(course)
  const { navigateToCourse } = useGetCourseUrl()

  const getButtonLabel = () => {
    if (!course.isOwned) {
      return 'View course'
    }

    if (status.percentage === 0) {
      return (
        <>
          <PlayIcon /> Start course
        </>
      )
    }

    return (
      <>
        <PlayIcon /> Continue course
      </>
    )
  }

  return (
    <StyledCourseListItem
      onClick={() => navigateToCourse(course, course.isOwned)}
      $status={status.label}
      $isOwned={course.isOwned}
    >
      <div className="course-thumbnail">
        {course.isOwned && (
          <div className="course-status course-pill">
            {!!status.percentage && (
              <div className="progress-bar" style={{ width: `${status.percentage}%` }} />
            )}
            <div className="label">
              {status.label === 'Completed' && <CheckIcon />}
              {status.label}
            </div>
          </div>
        )}
        <div className="course-stats">
          <div className="course-stat course-pill">
            {formatMultipleString('lesson', getCourseLessonCount(course))}
          </div>
          <div className="course-stat course-pill">
            {formatVideoLength(getCourseVideoLength(course))}
          </div>
        </div>
        {course.coverImage && (
          <img src={getOptimizedImage(course.coverImage.fileHttpLink, { width: 500 })} alt="" />
        )}
      </div>
      <div className="course-details-container">
        <div className="course-details">
          <span className="course-title">{course.title}</span>
          <span className="course-description">
            {course.previewDescription || course.description}
          </span>
        </div>
        <button className="course-btn">{getButtonLabel()}</button>
      </div>
    </StyledCourseListItem>
  )
}

export default CourseListItem
